export const black = "#4f4f4f"
export const red = "#a3013c"
export const blue = "#0338a0"
export const gray = "#7a7a7a"
export const mobileWidth = "700px"
export const tabletWidth = "800px"
export const desktopWidth = "1200px"
